/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#getToolModeMap__anchor
 */
export default () => window.documentViewer.getToolModeMap();
